import { get, map, mapValues } from 'lodash'
import { getReq } from '../../utils/request'
import { formatDateWithTime } from '../../utils/helper'
import { IRatingsPayload, RatingOriginItem, RatingTableItem } from '../../reducers/ratings/actions'

const fetchRatingsList = async (params: any = {}) => {
	const queries = {
		limit: 20,
		page: 1,
		...params
	}

	const normalizeQueryParams = mapValues(queries, (query) => (query === false ? false : (query || undefined)))
	const { data } = await getReq('/api/admin/ratings', normalizeQueryParams)

	const originalData: RatingOriginItem[] = get(data, 'ratings', [])
	const tableData: RatingTableItem[] = map(originalData, (column) => ({
		key: column.id,
		id: column.id,
		userName: column.userName,
		comment: column.comment,
		jobName: column.jobName,
		taskRatings: column.taskRatings,
		rating: column.rating,
		createdAt: formatDateWithTime(column.createdAt),
		trusteeName: column.trusteeName || null,
		deletedByUserID: column.deletedByUserID || null,
		deletedByUserName: column.deletedByUserName || null,
		deletedAt: column.deletedAt ? formatDateWithTime(column.deletedAt) : null
	}))

	return {
		tableData,
		originalData,
		pagination: get(data, 'context')
	} as IRatingsPayload
}

export default fetchRatingsList
